import React from 'react'
import Form from '../Form'
import TextHeader from '../TextHeader'
import FormSection from '../../sections/Form'

const PostBlogEmbeddableForm = ({ cmsData }) => {
  const FormSectionData = {
    centered: true,
    fullWidth: true,
    greyBG: true,
    name: 'Embedded Form',
    sectionType: 'Form',
    items: [
      {
        fields: {
          name: 'Embed Form',
          content: cmsData.items['en-US'][1].fields.content['en-US'],
        },
      },
      {
        fields: {
          formType: 'embedded-form'
        }
      },
    ],
  }
  

  return (
    <FormSection
      blogListing={true}
      cmsData={FormSectionData}
      embedded={true}
      noShift={true}
      >
      <TextHeader
        title={
          <div className="blog-form-title">
            {cmsData.items['en-US'][0].fields.title['en-US']}
          </div>
        }
        theme={{
          size: 'tiny',
          align: 'center',
          width: 'wide',
        }}
      />
      <Form cmsData={FormSectionData} />
    </FormSection>
  )
}


export default PostBlogEmbeddableForm
